<template>
	<div class="mdc-card mgt-24 pdt-24 pdb-16 pdl-24 pdr-24">
					<div class="t-color4 t-color-bodyGrayA l-spacing36 font-r t-body3">{{ $t('1958')}}</div>
					<div class="mgt-8 mgb-16 font-m t-subtitle3">
						<vue-mathjax :formula="listData.question.contents" v-if="listData.question.useMathjax"></vue-mathjax>
						<div v-else>
							{{ listData.question.contents }}
						</div>
					</div>
					<div v-if="listData.question.image">
						<img class="round mgb-8" :src="listData.question.image.resourceUri" alt="" v-if="listData.question.image">
				</div>
					<div class="b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 box-54"
					 v-for="(choice, index) in multipleChoice" :key="index"
						:class="{'bg-contentBlue': choice.correct === true,  'bg-quizGray': choice.correct === false && choice.selected === false, 'bg-contentRed': choice.correct === false && choice.selected === true}">
						<div class="d-flex align-items-center">
							<div class="q-count t-body1 l-spacing48 font-rn t-color-quizBlack" v-if="choice.correct === false && choice.selected === false" >{{index+1}}</div>
							<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === false && choice.selected === true">close</i>
							<i class="material-icons t-color-white t-headline4 mgr-16 mgl--6" v-if="choice.correct === true">radio_button_unchecked</i>
							<div class="t-body1  font-r flex-grow-1"
							:class="choice.correct === true ? 't-color-white': choice.correct === false && choice.selected === true ? 't-color-white' : 't-color-quizBlack'"
							>
								<vue-mathjax :formula="choice.contents" v-if="listData.question.useMathjax"></vue-mathjax>
								<div v-else>
									{{ choice.contents }}
								</div>
							</div>
							<div class="t-headline9 t-color-whiteMedium" v-if="choice.selectionRatio">
								{{parseInt(choice.selectionRatio)}}%
							</div>
						</div>
													<div class="mgt-8 mgb-8" v-if="choice.image && choice.image.resourceUri">
								<img class="round" :src="choice.image.resourceUri" alt="">
							</div>
					</div>
				</div>
</template>

<script>
/**
 * 다중답안 문항 피드백 컴포넌트(choice multiful type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

export default {
	 props: ['listData', 'multipleChoice'],
	data() {
		return {
			questionImage:null
		}
	},
	mounted() {
		if(this.listData && this.listData.question && this.listData.question.image) {
			let getImage = this.listData.question.image.resourceUri.split('default_thumnail_en.jpg')
			if(getImage[1] !=''){
				this.questionImage = this.listData.question.image.resourceUri;
			} else {
				this.questionImage = null
			}
		}
	},
	components: {
	},

	
}
</script>
